export default {
    TASKLISTGET: 'task:listGet', //  获取任务列表
    PAGETOTAL: 'task:pageTotal', //list页码
    LISTLOADING: 'task:listLoading', // 获取loading状态
    GETTASKID: 'task:getTaskId',//获取任务id
    GETUSERLIST: 'user:GetList', // 获取用户列表
    GETPAGETOTAL:'user:pageTotal',// 获取用户列表总页数
    SHOWUSERLOADING: 'user:ShowLoading', // loading显示隐藏
    SHOWUSEREDIT: 'user:ShowEdit', // 编辑弹框显示隐藏
    SHOWUSERADD: 'user:ShowAdd', // 新增弹框显示隐藏
    GETDETAIL:'user:getInfo',//获取用户信息
}



// WEBPACK FOOTER //
// ./utils/constant.js